import React, { useState } from 'react';
import { Loader2, Truck } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import apiClient from '@/services/apiClient';

export const RedispatchDialog = ({ group, codes, staffId, geo, onClose, onDone }) => {
  const [vehicleNo, setVehicleNo] = useState('');
  const [transporter, setTransporter] = useState('');
  const [remarks, setRemarks] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!vehicleNo.trim()) { toast.error('Enter the new vehicle number'); return; }
    setBusy(true);
    try {
      const r = await apiClient.post('/outward/returns/redispatch', {
        staff_id: staffId, original_entry_id: group.original_entry_id, bundle_barcodes: codes,
        vehicle_no: vehicleNo, transporter_name: transporter, remarks, ...geo,
      });
      toast.success(r.data.message);
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Re-dispatch failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!group} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="otr-redispatch-dialog">
        <DialogHeader>
          <DialogTitle>Re-dispatch {codes.length} bundle(s)</DialogTitle>
          <DialogDescription>
            New outward entry for document {group?.document_barcode} → {group?.destination}. Previous vehicle: {group?.original_vehicle_no || '-'}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label>New vehicle no. *</Label>
            <Input value={vehicleNo} onChange={(e) => setVehicleNo(e.target.value.toUpperCase())} placeholder="TN 30 AB 1234" data-testid="otr-vehicle-input" />
          </div>
          <div className="space-y-1">
            <Label>Transporter</Label>
            <Input value={transporter} onChange={(e) => setTransporter(e.target.value)} placeholder="Transporter name" data-testid="otr-transporter-input" />
          </div>
          <div className="space-y-1">
            <Label>Remarks</Label>
            <Input value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder="Optional" data-testid="otr-remarks-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="otr-redispatch-cancel">Cancel</Button>
          <Button onClick={submit} disabled={busy} className="bg-[#2D5F4F] hover:bg-[#244d40]" data-testid="otr-redispatch-confirm">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Truck className="w-4 h-4 mr-2" />} Re-dispatch
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RedispatchDialog;
